// Traducciones extra para módulos nuevos
export const T_EXTRA = {
  es: {
    // Categorias Dashboard
    produccion: "Producción",
    inventario_cat: "Inventario",
    ventas_cat: "Ventas",
    finanzas_cat: "Finanzas",
    admin_cat: "Admin",

    // Gallinaza
    gallinaza: "Gallinaza",
    new_collection: "Nueva recolección",
    register_collection: "Registrar recolección",
    sell: "Vender",
    sell_manure: "Vender gallinaza",
    register_sale: "Registrar venta",
    in_stock: "En stock",
    sold: "Vendido",
    total_income: "Ingresos totales",
    no_collections: "Sin recolecciones registradas",
    collection_registered: "Recolección registrada",
    sale_registered: "Venta registrada",
    unit_measure: "Unidad de medida",
    kilograms: "Kilogramos",
    pounds: "Libras",
    quintals: "Quintales",
    sacks: "Sacos",
    quantity_in: "Cantidad en",
    available_quantity: "Cantidad disponible",
    sale_unit: "Unidad de venta",
    price_per: "Precio por",
    sale_date: "Fecha de venta",
    collection_date: "Fecha",
    delete_record: "¿Eliminar este registro?",
    all: "Todos",

    // Sensores
    sensores: "Sensores",
    sensors_iot: "Sensores IoT",
    manual_reading: "Registrar lectura manual",
    reading_registered: "Lectura registrada",
    total_readings: "Total lecturas",
    updating_every: "Actualizando cada 30s",
    paused: "Pausado",
    no_data: "Sin datos",
    out_of_range: "Fuera de rango",
    manual: "Manual",
    normal_range: "Rango normal",
    measure_type: "Tipo de medición",
    value: "Valor",
    save_reading: "Guardar lectura",
    sensor_temperature: "Temperatura",
    sensor_humidity: "Humedad",
    sensor_ammonia: "Amoniaco",
    sensor_water: "Agua",
    sensor_feed: "Alimento",
    sensor_weight: "Peso aves",

    // Home
    role: "Rol",
    no_batches_assigned: "No tienes lotes asignados aún.",
    batch: "Lote",
    day: "Día",
    of: "de",
    conversion: "Conversión",
    register_today: "REGISTRAR HOY",

    // Formulas
    formulas: "Fórmulas",
    new_formula: "Nueva fórmula",
    edit_formula: "Editar fórmula",
    no_formulas: "Sin fórmulas creadas",
    active_formulas: "Fórmulas",
    productions: "Producciones",
    produced: "producidas",
    no_productions: "Sin producciones registradas",
    phase: "Fase",
    protein_pct: "Proteína %",
    ingredients: "Ingredientes",
    add: "Agregar",
    must_sum_100: "Los ingredientes deben sumar 100%",
    cost: "Costo",
    cost_calculation: "Cálculo de costo",
    total_cost: "Costo total",
    per_lb: "por lb",
    breakdown: "Desglose",
    produce: "Producir",
    quantity_lb: "Cantidad a producir (lb)",
    register_production: "Registrar producción",
    production_registered: "Producción registrada",
    production_warning: "Esta acción descontará los ingredientes del inventario.",

    // Vacunaciones
    vacunaciones: "Vacunaciones",
    new_vaccination: "Nueva vacunación",
    edit_vaccination: "Editar vacunación",
    vaccine_product: "Vacuna / Producto",
    application_route: "Vía de aplicación",
    dose: "Dosis",
    birds_applied: "Aves aplicadas",
    birds: "aves",
    all_batches: "Todos los lotes",
    select: "Selecciona",

    // Medicaciones
    medicaciones: "Medicaciones",
    new_medication: "Nueva medicación",
    edit_medication: "Editar medicación",
    medication_product: "Medicamento",
    reason: "Motivo",
    in_progress: "En curso",
    active: "Activo",
    start_date: "Inicio",
    end_date: "Fin",
    prescribed_by: "Indicado por",
    withdrawal_days: "Período de retiro (días)",
    withdrawal_period: "Período retiro",
    withdrawal_help: "Días entre fin del tratamiento y venta/consumo",
    days: "días",

    // Tareas
    tareas: "Tareas",
    new_task: "Nueva tarea",
    edit_task: "Editar tarea",
    no_tasks: "Sin tareas",
    task_title: "Título",
    description: "Descripción",
    target_date: "Fecha objetivo",
    priority: "Prioridad",
    priority_high: "Alta",
    priority_medium: "Media",
    priority_low: "Baja",
    assigned_to: "Asignar a",
    pending_tasks: "Pendientes",
    completed_tasks: "Completadas",
    overdue: "Atrasadas",
    for_today: "Hoy",
    today_tag: "HOY",
    marked_completed: "Marcada como completada",
    marked_pending: "Marcada como pendiente",

    // Reportes de Campo
    reportes_campo: "Reportes de campo",
    new_report: "Nuevo reporte",
    edit_report: "Editar reporte",
    no_reports: "Sin reportes",
    pending_reports: "Pendientes",
    resolved_reports: "Resueltos",
    total: "Total",
    report_type: "Tipo de problema",
    report_desc_placeholder: "Describe el problema observado...",
    photo_url: "URL de foto",
    photo_help: "Sube la foto a un servicio externo y pega el link",
    view_photo: "Ver foto",
    resolve: "Resolver",
    reopen: "Reabrir",
    resolved: "Resuelto",
    report_created: "Reporte creado",
    marked_resolved: "Marcado como resuelto",
    marked_unresolved: "Marcado como pendiente",
    optional: "opcional",
    report_type_mortalidad_alta: "Mortalidad alta",
    report_type_enfermedad: "Enfermedad",
    report_type_equipo_fallando: "Equipo fallando",
    report_type_infraestructura: "Infraestructura",
    report_type_otro: "Otro",
    // Facturacion NCF + Multi-tenant
    view_detail: "Ver detalle",
    download_pdf: "Descargar PDF",
    select_sale: "Seleccionar venta",
    no_pending_sales: "No hay ventas pendientes de facturar",
    ncf_type: "Tipo NCF",
    fiscal_credit: "Credito Fiscal",
    final_consumer: "Consumo Final",
    special_regime: "Regimen Especial",
    government: "Gubernamental",
    new_sequence: "Nueva secuencia",
    ncf_sequences: "Secuencias NCF",
    issue_invoice: "Emitir factura",
    voided: "Anulada",
    client: "Cliente",
    product: "Producto",
    quantity: "Cantidad",
    price: "Precio",
    subtotal: "Subtotal",
    from: "Desde",
    until: "Hasta",
    current: "Actual",
    active: "Activa",
    inactive: "Inactiva",
    my_business: "Mi Negocio",
    business_info: "Informacion del Negocio",
    configure_business_info: "Configurar nombre, RNC, direccion...",
    business_name: "Nombre del Negocio",
    business_info_note: "Esta informacion aparecera en las facturas y documentos.",
    address: "Direccion",
    phone: "Telefono",
    saved: "Guardado",

    // CxC - Cuentas por Cobrar
    "cxc.titulo": "Cuentas por Cobrar",
    "cxc.total_por_cobrar": "Total por cobrar",
    "cxc.al_dia": "Al día (0-30 días)",
    "cxc.vencido": "Vencido (+30 días)",
    "cxc.credito_favor": "Crédito a favor",
    "cxc.distribucion_antiguedad": "Distribución por antigüedad",
    "cxc.buscar_cliente": "Buscar cliente, teléfono o RNC...",
    "cxc.filtro.todos": "Todos",
    "cxc.filtro.al_dia": "Al día",
    "cxc.filtro.vencido": "Vencidos",
    "cxc.cliente": "Cliente",
    "cxc.contacto": "Contacto",
    "cxc.saldo": "Saldo",
    "cxc.credito": "Crédito",
    "cxc.dias_mas_viejo": "Días",
    "cxc.ver_estado": "Ver estado",
    "cxc.estado_cuenta": "Estado de cuenta",
    "cxc.facturado": "Facturado",
    "cxc.pagado": "Pagado",
    "cxc.pendiente": "Pendiente",
    "cxc.aplicar_pago": "Aplicar pago",
    "cxc.usar_credito": "Usar crédito a favor",
    "cxc.facturas": "Facturas",
    "cxc.numero": "Número",
    "cxc.fecha": "Fecha",
    "cxc.total": "Total",
    "cxc.dias": "Días",
    "cxc.estado": "Estado",
    "cxc.estado.pagado": "Pagado",
    "cxc.estado.parcial": "Parcial",
    "cxc.estado.pendiente": "Pendiente",
    "cxc.historico_pagos": "Histórico de pagos",
    "cxc.factura": "Factura",
    "cxc.monto": "Monto",
    "cxc.metodo": "Método",
    "cxc.nota": "Nota",
    "cxc.creditos_historicos": "Créditos generados",
    "cxc.monto_original": "Monto",
    "cxc.metodo_pago": "Método de pago",
    "cxc.metodo.efectivo": "Efectivo",
    "cxc.metodo.transferencia": "Transferencia",
    "cxc.metodo.cheque": "Cheque",
    "cxc.metodo.tarjeta": "Tarjeta",
    "cxc.preview_distribucion": "Vista previa de distribución",
    "cxc.sobrante_credito": "Sobrante (crédito a favor)",
    "cxc.confirmar_pago": "Confirmar pago",
    "cxc.cancelar": "Cancelar",
    "cxc.cargando": "Cargando...",
    "cxc.sin_resultados": "Sin resultados",
    "cxc.msg.pago_aplicado": "Pago aplicado",
    "cxc.msg.facturas_pagadas": "Facturas pagadas",
    "cxc.msg.facturas_parciales": "Facturas parciales",
    "cxc.msg.credito_generado": "Crédito generado",
    "cxc.msg.credito_aplicado": "Crédito aplicado",
    "cxc.confirm.aplicar_credito": "Aplicar el crédito de",
    "cxc.confirm.a_facturas": "a las facturas pendientes?",
    "cxc.error.estado_cuenta": "Error al cargar estado de cuenta",
    "cxc.error.aplicar_pago": "Error al aplicar pago",
    "cxc.error.credito": "Error",
    "cxc.error.monto_invalido": "Monto inválido",

    // Soft-delete - Activos/Inactivos
    "soft.mostrar_inactivos": "Mostrar inactivos",
    "soft.desactivar": "Desactivar",
    "soft.restaurar": "Restaurar",
    "soft.eliminar_permanente": "Eliminar permanentemente",
    "soft.confirm_desactivar": "¿Desactivar este",
    "soft.podras_restaurar": "Podrás restaurarlo después.",
    "soft.confirm_permanente_1": "ATENCIÓN: Esto borra PERMANENTEMENTE este",
    "soft.confirm_permanente_2": "Esta acción NO se puede deshacer.",
    "soft.confirm_permanente_3": "¿Continuar?",
    "soft.escribir_borrar": "Para confirmar, escribe BORRAR",
    "soft.cancelado": "Operación cancelada",
    "soft.error_desactivar": "Error al desactivar",
    "soft.error_restaurar": "Error al restaurar",
    "soft.error_permanente": "Error al eliminar permanentemente",
    "soft.inactivo": "Inactivo",
    "soft.finalizado": "Finalizado",
    "soft.cancelado_estado": "Cancelado",
  },
  en: {
    produccion: "Production",
    inventario_cat: "Inventory",
    ventas_cat: "Sales",
    finanzas_cat: "Finance",
    admin_cat: "Admin",

    gallinaza: "Manure",
    new_collection: "New collection",
    register_collection: "Register collection",
    sell: "Sell",
    sell_manure: "Sell manure",
    register_sale: "Register sale",
    in_stock: "In stock",
    sold: "Sold",
    total_income: "Total income",
    no_collections: "No collections registered",
    collection_registered: "Collection registered",
    sale_registered: "Sale registered",
    unit_measure: "Unit of measure",
    kilograms: "Kilograms",
    pounds: "Pounds",
    quintals: "Quintals",
    sacks: "Sacks",
    quantity_in: "Quantity in",
    available_quantity: "Available quantity",
    sale_unit: "Sale unit",
    price_per: "Price per",
    sale_date: "Sale date",
    collection_date: "Date",
    delete_record: "Delete this record?",
    all: "All",

    sensores: "Sensors",
    sensors_iot: "IoT Sensors",
    manual_reading: "Register manual reading",
    reading_registered: "Reading registered",
    total_readings: "Total readings",
    updating_every: "Refreshing every 30s",
    paused: "Paused",
    no_data: "No data",
    out_of_range: "Out of range",
    manual: "Manual",
    normal_range: "Normal range",
    measure_type: "Measure type",
    value: "Value",
    save_reading: "Save reading",
    sensor_temperature: "Temperature",
    sensor_humidity: "Humidity",
    sensor_ammonia: "Ammonia",
    sensor_water: "Water",
    sensor_feed: "Feed",
    sensor_weight: "Bird weight",

    role: "Role",
    no_batches_assigned: "You don't have any batches assigned yet.",
    batch: "Batch",
    day: "Day",
    of: "of",
    conversion: "Conversion",
    register_today: "REGISTER TODAY",

    formulas: "Formulas",
    new_formula: "New formula",
    edit_formula: "Edit formula",
    no_formulas: "No formulas created",
    active_formulas: "Formulas",
    productions: "Productions",
    produced: "produced",
    no_productions: "No productions registered",
    phase: "Phase",
    protein_pct: "Protein %",
    ingredients: "Ingredients",
    add: "Add",
    must_sum_100: "Ingredients must sum 100%",
    cost: "Cost",
    cost_calculation: "Cost calculation",
    total_cost: "Total cost",
    per_lb: "per lb",
    breakdown: "Breakdown",
    produce: "Produce",
    quantity_lb: "Quantity to produce (lb)",
    register_production: "Register production",
    production_registered: "Production registered",
    production_warning: "This action will deduct ingredients from inventory.",

    vacunaciones: "Vaccinations",
    new_vaccination: "New vaccination",
    edit_vaccination: "Edit vaccination",
    vaccine_product: "Vaccine / Product",
    application_route: "Application route",
    dose: "Dose",
    birds_applied: "Birds applied",
    birds: "birds",
    all_batches: "All batches",
    select: "Select",

    medicaciones: "Medications",
    new_medication: "New medication",
    edit_medication: "Edit medication",
    medication_product: "Medication",
    reason: "Reason",
    in_progress: "In progress",
    active: "Active",
    start_date: "Start",
    end_date: "End",
    prescribed_by: "Prescribed by",
    withdrawal_days: "Withdrawal period (days)",
    withdrawal_period: "Withdrawal period",
    withdrawal_help: "Days between end of treatment and sale/consumption",
    days: "days",

    tareas: "Tasks",
    new_task: "New task",
    edit_task: "Edit task",
    no_tasks: "No tasks",
    task_title: "Title",
    description: "Description",
    target_date: "Target date",
    priority: "Priority",
    priority_high: "High",
    priority_medium: "Medium",
    priority_low: "Low",
    assigned_to: "Assign to",
    pending_tasks: "Pending",
    completed_tasks: "Completed",
    overdue: "Overdue",
    for_today: "Today",
    today_tag: "TODAY",
    marked_completed: "Marked as completed",
    marked_pending: "Marked as pending",

    reportes_campo: "Field reports",
    new_report: "New report",
    edit_report: "Edit report",
    no_reports: "No reports",
    pending_reports: "Pending",
    resolved_reports: "Resolved",
    total: "Total",
    report_type: "Problem type",
    report_desc_placeholder: "Describe the observed problem...",
    photo_url: "Photo URL",
    photo_help: "Upload the photo to an external service and paste the link",
    view_photo: "View photo",
    resolve: "Resolve",
    reopen: "Reopen",
    resolved: "Resolved",
    report_created: "Report created",
    marked_resolved: "Marked as resolved",
    marked_unresolved: "Marked as pending",
    optional: "optional",
    report_type_mortalidad_alta: "High mortality",
    report_type_enfermedad: "Disease",
    report_type_equipo_fallando: "Equipment failure",
    report_type_infraestructura: "Infrastructure",
    report_type_otro: "Other",
    // Invoicing NCF + Multi-tenant
    view_detail: "View detail",
    download_pdf: "Download PDF",
    select_sale: "Select sale",
    no_pending_sales: "No pending sales to invoice",
    ncf_type: "NCF Type",
    fiscal_credit: "Fiscal Credit",
    final_consumer: "Final Consumer",
    special_regime: "Special Regime",
    government: "Government",
    new_sequence: "New sequence",
    ncf_sequences: "NCF Sequences",
    issue_invoice: "Issue invoice",
    voided: "Voided",
    client: "Client",
    product: "Product",
    quantity: "Quantity",
    price: "Price",
    subtotal: "Subtotal",
    from: "From",
    until: "Until",
    current: "Current",
    active: "Active",
    inactive: "Inactive",
    my_business: "My Business",
    business_info: "Business Information",
    configure_business_info: "Configure name, tax ID, address...",
    business_name: "Business Name",
    business_info_note: "This information will appear on invoices and documents.",
    address: "Address",
    phone: "Phone",
    saved: "Saved",

    // CxC - Cuentas por Cobrar
    "cxc.titulo": "Accounts Receivable",
    "cxc.total_por_cobrar": "Total receivable",
    "cxc.al_dia": "Current (0-30 days)",
    "cxc.vencido": "Overdue (+30 days)",
    "cxc.credito_favor": "Customer credit",
    "cxc.distribucion_antiguedad": "Aging breakdown",
    "cxc.buscar_cliente": "Search customer, phone or tax ID...",
    "cxc.filtro.todos": "All",
    "cxc.filtro.al_dia": "Current",
    "cxc.filtro.vencido": "Overdue",
    "cxc.cliente": "Customer",
    "cxc.contacto": "Contact",
    "cxc.saldo": "Balance",
    "cxc.credito": "Credit",
    "cxc.dias_mas_viejo": "Days",
    "cxc.ver_estado": "View statement",
    "cxc.estado_cuenta": "Account statement",
    "cxc.facturado": "Billed",
    "cxc.pagado": "Paid",
    "cxc.pendiente": "Outstanding",
    "cxc.aplicar_pago": "Apply payment",
    "cxc.usar_credito": "Use customer credit",
    "cxc.facturas": "Invoices",
    "cxc.numero": "Number",
    "cxc.fecha": "Date",
    "cxc.total": "Total",
    "cxc.dias": "Days",
    "cxc.estado": "Status",
    "cxc.estado.pagado": "Paid",
    "cxc.estado.parcial": "Partial",
    "cxc.estado.pendiente": "Pending",
    "cxc.historico_pagos": "Payment history",
    "cxc.factura": "Invoice",
    "cxc.monto": "Amount",
    "cxc.metodo": "Method",
    "cxc.nota": "Note",
    "cxc.creditos_historicos": "Generated credits",
    "cxc.monto_original": "Amount",
    "cxc.metodo_pago": "Payment method",
    "cxc.metodo.efectivo": "Cash",
    "cxc.metodo.transferencia": "Transfer",
    "cxc.metodo.cheque": "Check",
    "cxc.metodo.tarjeta": "Card",
    "cxc.preview_distribucion": "Distribution preview",
    "cxc.sobrante_credito": "Excess (customer credit)",
    "cxc.confirmar_pago": "Confirm payment",
    "cxc.cancelar": "Cancel",
    "cxc.cargando": "Loading...",
    "cxc.sin_resultados": "No results",
    "cxc.msg.pago_aplicado": "Payment applied",
    "cxc.msg.facturas_pagadas": "Invoices paid",
    "cxc.msg.facturas_parciales": "Partial invoices",
    "cxc.msg.credito_generado": "Credit generated",
    "cxc.msg.credito_aplicado": "Credit applied",
    "cxc.confirm.aplicar_credito": "Apply the credit of",
    "cxc.confirm.a_facturas": "to pending invoices?",
    "cxc.error.estado_cuenta": "Error loading statement",
    "cxc.error.aplicar_pago": "Error applying payment",
    "cxc.error.credito": "Error",
    "cxc.error.monto_invalido": "Invalid amount",

    // Soft-delete - Activos/Inactivos
    "soft.mostrar_inactivos": "Show inactive",
    "soft.desactivar": "Deactivate",
    "soft.restaurar": "Restore",
    "soft.eliminar_permanente": "Delete permanently",
    "soft.confirm_desactivar": "Deactivate this",
    "soft.podras_restaurar": "You can restore it later.",
    "soft.confirm_permanente_1": "WARNING: This permanently deletes this",
    "soft.confirm_permanente_2": "This action CANNOT be undone.",
    "soft.confirm_permanente_3": "Continue?",
    "soft.escribir_borrar": "To confirm, type BORRAR",
    "soft.cancelado": "Operation cancelled",
    "soft.error_desactivar": "Error deactivating",
    "soft.error_restaurar": "Error restoring",
    "soft.error_permanente": "Error deleting permanently",
    "soft.inactivo": "Inactive",
    "soft.finalizado": "Finished",
    "soft.cancelado_estado": "Cancelled",
  },
  fr: {
    produccion: "Production",
    inventario_cat: "Inventaire",
    ventas_cat: "Ventes",
    finanzas_cat: "Finances",
    admin_cat: "Admin",

    gallinaza: "Fumier",
    new_collection: "Nouvelle collecte",
    register_collection: "Enregistrer collecte",
    sell: "Vendre",
    sell_manure: "Vendre fumier",
    register_sale: "Enregistrer vente",
    in_stock: "En stock",
    sold: "Vendu",
    total_income: "Revenus totaux",
    no_collections: "Aucune collecte enregistrée",
    collection_registered: "Collecte enregistrée",
    sale_registered: "Vente enregistrée",
    unit_measure: "Unité de mesure",
    kilograms: "Kilogrammes",
    pounds: "Livres",
    quintals: "Quintaux",
    sacks: "Sacs",
    quantity_in: "Quantité en",
    available_quantity: "Quantité disponible",
    sale_unit: "Unité de vente",
    price_per: "Prix par",
    sale_date: "Date de vente",
    collection_date: "Date",
    delete_record: "Supprimer cet enregistrement?",
    all: "Tous",

    sensores: "Capteurs",
    sensors_iot: "Capteurs IoT",
    manual_reading: "Enregistrer lecture manuelle",
    reading_registered: "Lecture enregistrée",
    total_readings: "Total lectures",
    updating_every: "Actualisation toutes les 30s",
    paused: "En pause",
    no_data: "Pas de données",
    out_of_range: "Hors limites",
    manual: "Manuel",
    normal_range: "Plage normale",
    measure_type: "Type de mesure",
    value: "Valeur",
    save_reading: "Enregistrer lecture",
    sensor_temperature: "Température",
    sensor_humidity: "Humidité",
    sensor_ammonia: "Ammoniac",
    sensor_water: "Eau",
    sensor_feed: "Aliment",
    sensor_weight: "Poids oiseaux",

    role: "Rôle",
    no_batches_assigned: "Vous n'avez pas encore de lots assignés.",
    batch: "Lot",
    day: "Jour",
    of: "de",
    conversion: "Conversion",
    register_today: "ENREGISTRER AUJOURD'HUI",

    formulas: "Formules",
    new_formula: "Nouvelle formule",
    edit_formula: "Modifier formule",
    no_formulas: "Aucune formule créée",
    active_formulas: "Formules",
    productions: "Productions",
    produced: "produites",
    no_productions: "Aucune production enregistrée",
    phase: "Phase",
    protein_pct: "Protéines %",
    ingredients: "Ingrédients",
    add: "Ajouter",
    must_sum_100: "Les ingrédients doivent totaliser 100%",
    cost: "Coût",
    cost_calculation: "Calcul du coût",
    total_cost: "Coût total",
    per_lb: "par lb",
    breakdown: "Détail",
    produce: "Produire",
    quantity_lb: "Quantité à produire (lb)",
    register_production: "Enregistrer production",
    production_registered: "Production enregistrée",
    production_warning: "Cette action déduira les ingrédients de l'inventaire.",

    vacunaciones: "Vaccinations",
    new_vaccination: "Nouvelle vaccination",
    edit_vaccination: "Modifier vaccination",
    vaccine_product: "Vaccin / Produit",
    application_route: "Voie d'application",
    dose: "Dose",
    birds_applied: "Oiseaux appliqués",
    birds: "oiseaux",
    all_batches: "Tous les lots",
    select: "Sélectionner",

    medicaciones: "Médications",
    new_medication: "Nouvelle médication",
    edit_medication: "Modifier médication",
    medication_product: "Médicament",
    reason: "Motif",
    in_progress: "En cours",
    active: "Actif",
    start_date: "Début",
    end_date: "Fin",
    prescribed_by: "Prescrit par",
    withdrawal_days: "Délai de retrait (jours)",
    withdrawal_period: "Délai de retrait",
    withdrawal_help: "Jours entre fin du traitement et vente/consommation",
    days: "jours",

    tareas: "Tâches",
    new_task: "Nouvelle tâche",
    edit_task: "Modifier tâche",
    no_tasks: "Aucune tâche",
    task_title: "Titre",
    description: "Description",
    target_date: "Date objectif",
    priority: "Priorité",
    priority_high: "Haute",
    priority_medium: "Moyenne",
    priority_low: "Basse",
    assigned_to: "Assigner à",
    pending_tasks: "En attente",
    completed_tasks: "Terminées",
    overdue: "En retard",
    for_today: "Aujourd'hui",
    today_tag: "AUJ.",
    marked_completed: "Marquée comme terminée",
    marked_pending: "Marquée comme en attente",

    reportes_campo: "Rapports terrain",
    new_report: "Nouveau rapport",
    edit_report: "Modifier rapport",
    no_reports: "Aucun rapport",
    pending_reports: "En attente",
    resolved_reports: "Résolus",
    total: "Total",
    report_type: "Type de problème",
    report_desc_placeholder: "Décrivez le problème observé...",
    photo_url: "URL de la photo",
    photo_help: "Téléchargez la photo sur un service externe et collez le lien",
    view_photo: "Voir la photo",
    resolve: "Résoudre",
    reopen: "Rouvrir",
    resolved: "Résolu",
    report_created: "Rapport créé",
    marked_resolved: "Marqué comme résolu",
    marked_unresolved: "Marqué comme en attente",
    optional: "facultatif",
    report_type_mortalidad_alta: "Mortalité élevée",
    report_type_enfermedad: "Maladie",
    report_type_equipo_fallando: "Panne d'équipement",
    report_type_infraestructura: "Infrastructure",
    report_type_otro: "Autre",
    // Facturation NCF + Multi-tenant
    view_detail: "Voir detail",
    download_pdf: "Telecharger PDF",
    select_sale: "Selectionner vente",
    no_pending_sales: "Aucune vente en attente de facturation",
    ncf_type: "Type NCF",
    fiscal_credit: "Credit Fiscal",
    final_consumer: "Consommateur Final",
    special_regime: "Regime Special",
    government: "Gouvernemental",
    new_sequence: "Nouvelle sequence",
    ncf_sequences: "Sequences NCF",
    issue_invoice: "Emettre facture",
    voided: "Annulee",
    client: "Client",
    product: "Produit",
    quantity: "Quantite",
    price: "Prix",
    subtotal: "Sous-total",
    from: "De",
    until: "Jusqu'a",
    current: "Actuel",
    active: "Active",
    inactive: "Inactive",
    my_business: "Mon Entreprise",
    business_info: "Informations de l'Entreprise",
    configure_business_info: "Configurer nom, identifiant fiscal, adresse...",
    business_name: "Nom de l'Entreprise",
    business_info_note: "Ces informations apparaitront sur les factures et documents.",
    address: "Adresse",
    phone: "Telephone",
    saved: "Enregistre",

    // CxC - Cuentas por Cobrar
    "cxc.titulo": "Comptes clients",
    "cxc.total_por_cobrar": "Total à recevoir",
    "cxc.al_dia": "À jour (0-30 jours)",
    "cxc.vencido": "En retard (+30 jours)",
    "cxc.credito_favor": "Crédit client",
    "cxc.distribucion_antiguedad": "Répartition par ancienneté",
    "cxc.buscar_cliente": "Rechercher client, tél. ou ID fiscal...",
    "cxc.filtro.todos": "Tous",
    "cxc.filtro.al_dia": "À jour",
    "cxc.filtro.vencido": "En retard",
    "cxc.cliente": "Client",
    "cxc.contacto": "Contact",
    "cxc.saldo": "Solde",
    "cxc.credito": "Crédit",
    "cxc.dias_mas_viejo": "Jours",
    "cxc.ver_estado": "Voir relevé",
    "cxc.estado_cuenta": "Relevé de compte",
    "cxc.facturado": "Facturé",
    "cxc.pagado": "Payé",
    "cxc.pendiente": "En attente",
    "cxc.aplicar_pago": "Appliquer paiement",
    "cxc.usar_credito": "Utiliser crédit client",
    "cxc.facturas": "Factures",
    "cxc.numero": "Numéro",
    "cxc.fecha": "Date",
    "cxc.total": "Total",
    "cxc.dias": "Jours",
    "cxc.estado": "État",
    "cxc.estado.pagado": "Payé",
    "cxc.estado.parcial": "Partiel",
    "cxc.estado.pendiente": "En attente",
    "cxc.historico_pagos": "Historique des paiements",
    "cxc.factura": "Facture",
    "cxc.monto": "Montant",
    "cxc.metodo": "Méthode",
    "cxc.nota": "Note",
    "cxc.creditos_historicos": "Crédits générés",
    "cxc.monto_original": "Montant",
    "cxc.metodo_pago": "Méthode de paiement",
    "cxc.metodo.efectivo": "Espèces",
    "cxc.metodo.transferencia": "Virement",
    "cxc.metodo.cheque": "Chèque",
    "cxc.metodo.tarjeta": "Carte",
    "cxc.preview_distribucion": "Aperçu de la distribution",
    "cxc.sobrante_credito": "Excédent (crédit client)",
    "cxc.confirmar_pago": "Confirmer le paiement",
    "cxc.cancelar": "Annuler",
    "cxc.cargando": "Chargement...",
    "cxc.sin_resultados": "Aucun résultat",
    "cxc.msg.pago_aplicado": "Paiement appliqué",
    "cxc.msg.facturas_pagadas": "Factures payées",
    "cxc.msg.facturas_parciales": "Factures partielles",
    "cxc.msg.credito_generado": "Crédit généré",
    "cxc.msg.credito_aplicado": "Crédit appliqué",
    "cxc.confirm.aplicar_credito": "Appliquer le crédit de",
    "cxc.confirm.a_facturas": "aux factures impayées ?",
    "cxc.error.estado_cuenta": "Erreur chargement relevé",
    "cxc.error.aplicar_pago": "Erreur application paiement",
    "cxc.error.credito": "Erreur",
    "cxc.error.monto_invalido": "Montant invalide",

    // Soft-delete - Activos/Inactivos
    "soft.mostrar_inactivos": "Afficher inactifs",
    "soft.desactivar": "Désactiver",
    "soft.restaurar": "Restaurer",
    "soft.eliminar_permanente": "Supprimer définitivement",
    "soft.confirm_desactivar": "Désactiver ce",
    "soft.podras_restaurar": "Vous pourrez le restaurer plus tard.",
    "soft.confirm_permanente_1": "ATTENTION : Cela supprime DÉFINITIVEMENT ce",
    "soft.confirm_permanente_2": "Cette action ne peut PAS être annulée.",
    "soft.confirm_permanente_3": "Continuer ?",
    "soft.escribir_borrar": "Pour confirmer, tapez BORRAR",
    "soft.cancelado": "Opération annulée",
    "soft.error_desactivar": "Erreur de désactivation",
    "soft.error_restaurar": "Erreur de restauration",
    "soft.error_permanente": "Erreur de suppression définitive",
    "soft.inactivo": "Inactif",
    "soft.finalizado": "Terminé",
    "soft.cancelado_estado": "Annulé",
  },
  de: {
    produccion: "Produktion",
    inventario_cat: "Bestand",
    ventas_cat: "Verkauf",
    finanzas_cat: "Finanzen",
    admin_cat: "Admin",

    gallinaza: "Hühnermist",
    new_collection: "Neue Sammlung",
    register_collection: "Sammlung erfassen",
    sell: "Verkaufen",
    sell_manure: "Mist verkaufen",
    register_sale: "Verkauf erfassen",
    in_stock: "Auf Lager",
    sold: "Verkauft",
    total_income: "Gesamteinnahmen",
    no_collections: "Keine Sammlungen erfasst",
    collection_registered: "Sammlung erfasst",
    sale_registered: "Verkauf erfasst",
    unit_measure: "Maßeinheit",
    kilograms: "Kilogramm",
    pounds: "Pfund",
    quintals: "Zentner",
    sacks: "Säcke",
    quantity_in: "Menge in",
    available_quantity: "Verfügbare Menge",
    sale_unit: "Verkaufseinheit",
    price_per: "Preis pro",
    sale_date: "Verkaufsdatum",
    collection_date: "Datum",
    delete_record: "Diesen Datensatz löschen?",
    all: "Alle",

    sensores: "Sensoren",
    sensors_iot: "IoT-Sensoren",
    manual_reading: "Manuelle Messung erfassen",
    reading_registered: "Messung erfasst",
    total_readings: "Messungen gesamt",
    updating_every: "Aktualisierung alle 30s",
    paused: "Pausiert",
    no_data: "Keine Daten",
    out_of_range: "Außerhalb des Bereichs",
    manual: "Manuell",
    normal_range: "Normalbereich",
    measure_type: "Messtyp",
    value: "Wert",
    save_reading: "Messung speichern",
    sensor_temperature: "Temperatur",
    sensor_humidity: "Feuchtigkeit",
    sensor_ammonia: "Ammoniak",
    sensor_water: "Wasser",
    sensor_feed: "Futter",
    sensor_weight: "Vogelgewicht",

    role: "Rolle",
    no_batches_assigned: "Sie haben noch keine Chargen zugewiesen.",
    batch: "Charge",
    day: "Tag",
    of: "von",
    conversion: "Umrechnung",
    register_today: "HEUTE ERFASSEN",

    formulas: "Rezepturen",
    new_formula: "Neue Rezeptur",
    edit_formula: "Rezeptur bearbeiten",
    no_formulas: "Keine Rezepturen erstellt",
    active_formulas: "Rezepturen",
    productions: "Produktionen",
    produced: "produziert",
    no_productions: "Keine Produktionen erfasst",
    phase: "Phase",
    protein_pct: "Protein %",
    ingredients: "Zutaten",
    add: "Hinzufügen",
    must_sum_100: "Zutaten müssen 100% ergeben",
    cost: "Kosten",
    cost_calculation: "Kostenberechnung",
    total_cost: "Gesamtkosten",
    per_lb: "pro lb",
    breakdown: "Aufschlüsselung",
    produce: "Produzieren",
    quantity_lb: "Zu produzierende Menge (lb)",
    register_production: "Produktion erfassen",
    production_registered: "Produktion erfasst",
    production_warning: "Diese Aktion zieht Zutaten vom Bestand ab.",

    vacunaciones: "Impfungen",
    new_vaccination: "Neue Impfung",
    edit_vaccination: "Impfung bearbeiten",
    vaccine_product: "Impfstoff / Produkt",
    application_route: "Verabreichungsweg",
    dose: "Dosis",
    birds_applied: "Geimpfte Vögel",
    birds: "Vögel",
    all_batches: "Alle Chargen",
    select: "Auswählen",

    medicaciones: "Medikationen",
    new_medication: "Neue Medikation",
    edit_medication: "Medikation bearbeiten",
    medication_product: "Medikament",
    reason: "Grund",
    in_progress: "In Bearbeitung",
    active: "Aktiv",
    start_date: "Beginn",
    end_date: "Ende",
    prescribed_by: "Verschrieben von",
    withdrawal_days: "Wartezeit (Tage)",
    withdrawal_period: "Wartezeit",
    withdrawal_help: "Tage zwischen Behandlungsende und Verkauf/Verzehr",
    days: "Tage",

    tareas: "Aufgaben",
    new_task: "Neue Aufgabe",
    edit_task: "Aufgabe bearbeiten",
    no_tasks: "Keine Aufgaben",
    task_title: "Titel",
    description: "Beschreibung",
    target_date: "Zieldatum",
    priority: "Priorität",
    priority_high: "Hoch",
    priority_medium: "Mittel",
    priority_low: "Niedrig",
    assigned_to: "Zuweisen an",
    pending_tasks: "Ausstehend",
    completed_tasks: "Erledigt",
    overdue: "Überfällig",
    for_today: "Heute",
    today_tag: "HEUTE",
    marked_completed: "Als erledigt markiert",
    marked_pending: "Als ausstehend markiert",

    reportes_campo: "Feldberichte",
    new_report: "Neuer Bericht",
    edit_report: "Bericht bearbeiten",
    no_reports: "Keine Berichte",
    pending_reports: "Ausstehend",
    resolved_reports: "Gelöst",
    total: "Gesamt",
    report_type: "Problemtyp",
    report_desc_placeholder: "Beschreiben Sie das beobachtete Problem...",
    photo_url: "Foto-URL",
    photo_help: "Foto auf einem externen Dienst hochladen und Link einfügen",
    view_photo: "Foto ansehen",
    resolve: "Lösen",
    reopen: "Wieder öffnen",
    resolved: "Gelöst",
    report_created: "Bericht erstellt",
    marked_resolved: "Als gelöst markiert",
    marked_unresolved: "Als ausstehend markiert",
    optional: "optional",
    report_type_mortalidad_alta: "Hohe Sterblichkeit",
    report_type_enfermedad: "Krankheit",
    report_type_equipo_fallando: "Ausrüstungsausfall",
    report_type_infraestructura: "Infrastruktur",
    report_type_otro: "Sonstiges",
    // Rechnungsstellung NCF + Multi-tenant
    view_detail: "Detail anzeigen",
    download_pdf: "PDF herunterladen",
    select_sale: "Verkauf auswaehlen",
    no_pending_sales: "Keine ausstehenden Verkaeufe zur Rechnungsstellung",
    ncf_type: "NCF-Typ",
    fiscal_credit: "Steuergutschrift",
    final_consumer: "Endverbraucher",
    special_regime: "Sonderregelung",
    government: "Behoerdlich",
    new_sequence: "Neue Sequenz",
    ncf_sequences: "NCF-Sequenzen",
    issue_invoice: "Rechnung ausstellen",
    voided: "Storniert",
    client: "Kunde",
    product: "Produkt",
    quantity: "Menge",
    price: "Preis",
    subtotal: "Zwischensumme",
    from: "Von",
    until: "Bis",
    current: "Aktuell",
    active: "Aktiv",
    inactive: "Inaktiv",
    my_business: "Mein Unternehmen",
    business_info: "Unternehmensinformationen",
    configure_business_info: "Name, Steuer-ID, Adresse konfigurieren...",
    business_name: "Unternehmensname",
    business_info_note: "Diese Informationen erscheinen auf Rechnungen und Dokumenten.",
    address: "Adresse",
    phone: "Telefon",
    saved: "Gespeichert",

    // CxC - Cuentas por Cobrar
    "cxc.titulo": "Forderungen",
    "cxc.total_por_cobrar": "Gesamtforderungen",
    "cxc.al_dia": "Aktuell (0-30 Tage)",
    "cxc.vencido": "Überfällig (+30 Tage)",
    "cxc.credito_favor": "Kundenguthaben",
    "cxc.distribucion_antiguedad": "Altersanalyse",
    "cxc.buscar_cliente": "Suche Kunde, Tel. oder USt-ID...",
    "cxc.filtro.todos": "Alle",
    "cxc.filtro.al_dia": "Aktuell",
    "cxc.filtro.vencido": "Überfällig",
    "cxc.cliente": "Kunde",
    "cxc.contacto": "Kontakt",
    "cxc.saldo": "Saldo",
    "cxc.credito": "Guthaben",
    "cxc.dias_mas_viejo": "Tage",
    "cxc.ver_estado": "Auszug ansehen",
    "cxc.estado_cuenta": "Kontoauszug",
    "cxc.facturado": "Fakturiert",
    "cxc.pagado": "Bezahlt",
    "cxc.pendiente": "Offen",
    "cxc.aplicar_pago": "Zahlung anwenden",
    "cxc.usar_credito": "Guthaben nutzen",
    "cxc.facturas": "Rechnungen",
    "cxc.numero": "Nummer",
    "cxc.fecha": "Datum",
    "cxc.total": "Gesamt",
    "cxc.dias": "Tage",
    "cxc.estado": "Status",
    "cxc.estado.pagado": "Bezahlt",
    "cxc.estado.parcial": "Teilweise",
    "cxc.estado.pendiente": "Offen",
    "cxc.historico_pagos": "Zahlungsverlauf",
    "cxc.factura": "Rechnung",
    "cxc.monto": "Betrag",
    "cxc.metodo": "Methode",
    "cxc.nota": "Notiz",
    "cxc.creditos_historicos": "Generierte Guthaben",
    "cxc.monto_original": "Betrag",
    "cxc.metodo_pago": "Zahlungsmethode",
    "cxc.metodo.efectivo": "Bar",
    "cxc.metodo.transferencia": "Überweisung",
    "cxc.metodo.cheque": "Scheck",
    "cxc.metodo.tarjeta": "Karte",
    "cxc.preview_distribucion": "Verteilungsvorschau",
    "cxc.sobrante_credito": "Überschuss (Guthaben)",
    "cxc.confirmar_pago": "Zahlung bestätigen",
    "cxc.cancelar": "Abbrechen",
    "cxc.cargando": "Wird geladen...",
    "cxc.sin_resultados": "Keine Ergebnisse",
    "cxc.msg.pago_aplicado": "Zahlung angewendet",
    "cxc.msg.facturas_pagadas": "Bezahlte Rechnungen",
    "cxc.msg.facturas_parciales": "Teilrechnungen",
    "cxc.msg.credito_generado": "Guthaben erstellt",
    "cxc.msg.credito_aplicado": "Guthaben angewendet",
    "cxc.confirm.aplicar_credito": "Guthaben anwenden von",
    "cxc.confirm.a_facturas": "auf offene Rechnungen?",
    "cxc.error.estado_cuenta": "Fehler beim Laden des Auszugs",
    "cxc.error.aplicar_pago": "Fehler bei Zahlungsanwendung",
    "cxc.error.credito": "Fehler",
    "cxc.error.monto_invalido": "Ungültiger Betrag",

    // Soft-delete - Activos/Inactivos
    "soft.mostrar_inactivos": "Inaktive anzeigen",
    "soft.desactivar": "Deaktivieren",
    "soft.restaurar": "Wiederherstellen",
    "soft.eliminar_permanente": "Endgültig löschen",
    "soft.confirm_desactivar": "Diesen deaktivieren",
    "soft.podras_restaurar": "Sie können ihn später wiederherstellen.",
    "soft.confirm_permanente_1": "ACHTUNG: Dies löscht ENDGÜLTIG diesen",
    "soft.confirm_permanente_2": "Diese Aktion kann NICHT rückgängig gemacht werden.",
    "soft.confirm_permanente_3": "Fortfahren?",
    "soft.escribir_borrar": "Zur Bestätigung tippen Sie BORRAR",
    "soft.cancelado": "Vorgang abgebrochen",
    "soft.error_desactivar": "Fehler beim Deaktivieren",
    "soft.error_restaurar": "Fehler beim Wiederherstellen",
    "soft.error_permanente": "Fehler beim endgültigen Löschen",
    "soft.inactivo": "Inaktiv",
    "soft.finalizado": "Abgeschlossen",
    "soft.cancelado_estado": "Storniert",
  },
  it: {
    produccion: "Produzione",
    inventario_cat: "Inventario",
    ventas_cat: "Vendite",
    finanzas_cat: "Finanze",
    admin_cat: "Admin",

    gallinaza: "Pollina",
    new_collection: "Nuova raccolta",
    register_collection: "Registra raccolta",
    sell: "Vendere",
    sell_manure: "Vendere pollina",
    register_sale: "Registra vendita",
    in_stock: "In magazzino",
    sold: "Venduto",
    total_income: "Entrate totali",
    no_collections: "Nessuna raccolta registrata",
    collection_registered: "Raccolta registrata",
    sale_registered: "Vendita registrata",
    unit_measure: "Unità di misura",
    kilograms: "Chilogrammi",
    pounds: "Libbre",
    quintals: "Quintali",
    sacks: "Sacchi",
    quantity_in: "Quantità in",
    available_quantity: "Quantità disponibile",
    sale_unit: "Unità di vendita",
    price_per: "Prezzo per",
    sale_date: "Data di vendita",
    collection_date: "Data",
    delete_record: "Eliminare questo record?",
    all: "Tutti",

    sensores: "Sensori",
    sensors_iot: "Sensori IoT",
    manual_reading: "Registra lettura manuale",
    reading_registered: "Lettura registrata",
    total_readings: "Letture totali",
    updating_every: "Aggiornamento ogni 30s",
    paused: "In pausa",
    no_data: "Nessun dato",
    out_of_range: "Fuori range",
    manual: "Manuale",
    normal_range: "Range normale",
    measure_type: "Tipo di misura",
    value: "Valore",
    save_reading: "Salva lettura",
    sensor_temperature: "Temperatura",
    sensor_humidity: "Umidità",
    sensor_ammonia: "Ammoniaca",
    sensor_water: "Acqua",
    sensor_feed: "Mangime",
    sensor_weight: "Peso uccelli",

    role: "Ruolo",
    no_batches_assigned: "Non hai ancora lotti assegnati.",
    batch: "Lotto",
    day: "Giorno",
    of: "di",
    conversion: "Conversione",
    register_today: "REGISTRA OGGI",

    formulas: "Formule",
    new_formula: "Nuova formula",
    edit_formula: "Modifica formula",
    no_formulas: "Nessuna formula creata",
    active_formulas: "Formule",
    productions: "Produzioni",
    produced: "prodotte",
    no_productions: "Nessuna produzione registrata",
    phase: "Fase",
    protein_pct: "Proteine %",
    ingredients: "Ingredienti",
    add: "Aggiungi",
    must_sum_100: "Gli ingredienti devono sommare 100%",
    cost: "Costo",
    cost_calculation: "Calcolo costo",
    total_cost: "Costo totale",
    per_lb: "per lb",
    breakdown: "Dettaglio",
    produce: "Produrre",
    quantity_lb: "Quantità da produrre (lb)",
    register_production: "Registra produzione",
    production_registered: "Produzione registrata",
    production_warning: "Questa azione detrarrà gli ingredienti dall'inventario.",

    vacunaciones: "Vaccinazioni",
    new_vaccination: "Nuova vaccinazione",
    edit_vaccination: "Modifica vaccinazione",
    vaccine_product: "Vaccino / Prodotto",
    application_route: "Via di applicazione",
    dose: "Dose",
    birds_applied: "Uccelli applicati",
    birds: "uccelli",
    all_batches: "Tutti i lotti",
    select: "Seleziona",

    medicaciones: "Medicazioni",
    new_medication: "Nuova medicazione",
    edit_medication: "Modifica medicazione",
    medication_product: "Farmaco",
    reason: "Motivo",
    in_progress: "In corso",
    active: "Attivo",
    start_date: "Inizio",
    end_date: "Fine",
    prescribed_by: "Prescritto da",
    withdrawal_days: "Periodo di sospensione (giorni)",
    withdrawal_period: "Periodo di sospensione",
    withdrawal_help: "Giorni tra fine trattamento e vendita/consumo",
    days: "giorni",

    tareas: "Attività",
    new_task: "Nuova attività",
    edit_task: "Modifica attività",
    no_tasks: "Nessuna attività",
    task_title: "Titolo",
    description: "Descrizione",
    target_date: "Data obiettivo",
    priority: "Priorità",
    priority_high: "Alta",
    priority_medium: "Media",
    priority_low: "Bassa",
    assigned_to: "Assegnare a",
    pending_tasks: "In sospeso",
    completed_tasks: "Completate",
    overdue: "In ritardo",
    for_today: "Oggi",
    today_tag: "OGGI",
    marked_completed: "Segnata come completata",
    marked_pending: "Segnata come in sospeso",

    reportes_campo: "Report di campo",
    new_report: "Nuovo report",
    edit_report: "Modifica report",
    no_reports: "Nessun report",
    pending_reports: "In sospeso",
    resolved_reports: "Risolti",
    total: "Totale",
    report_type: "Tipo di problema",
    report_desc_placeholder: "Descrivi il problema osservato...",
    photo_url: "URL foto",
    photo_help: "Carica la foto su un servizio esterno e incolla il link",
    view_photo: "Vedi foto",
    resolve: "Risolvi",
    reopen: "Riapri",
    resolved: "Risolto",
    report_created: "Report creato",
    marked_resolved: "Segnato come risolto",
    marked_unresolved: "Segnato come in sospeso",
    optional: "opzionale",
    report_type_mortalidad_alta: "Alta mortalità",
    report_type_enfermedad: "Malattia",
    report_type_equipo_fallando: "Guasto attrezzatura",
    report_type_infraestructura: "Infrastruttura",
    report_type_otro: "Altro",
    // Fatturazione NCF + Multi-tenant
    view_detail: "Vedi dettaglio",
    download_pdf: "Scarica PDF",
    select_sale: "Seleziona vendita",
    no_pending_sales: "Nessuna vendita in attesa di fatturazione",
    ncf_type: "Tipo NCF",
    fiscal_credit: "Credito Fiscale",
    final_consumer: "Consumatore Finale",
    special_regime: "Regime Speciale",
    government: "Governativo",
    new_sequence: "Nuova sequenza",
    ncf_sequences: "Sequenze NCF",
    issue_invoice: "Emetti fattura",
    voided: "Annullata",
    client: "Cliente",
    product: "Prodotto",
    quantity: "Quantita",
    price: "Prezzo",
    subtotal: "Subtotale",
    from: "Da",
    until: "Fino a",
    current: "Attuale",
    active: "Attiva",
    inactive: "Inattiva",
    my_business: "La Mia Azienda",
    business_info: "Informazioni Aziendali",
    configure_business_info: "Configura nome, partita IVA, indirizzo...",
    business_name: "Nome Azienda",
    business_info_note: "Queste informazioni appariranno su fatture e documenti.",
    address: "Indirizzo",
    phone: "Telefono",
    saved: "Salvato",

    // CxC - Cuentas por Cobrar
    "cxc.titulo": "Crediti verso clienti",
    "cxc.total_por_cobrar": "Totale crediti",
    "cxc.al_dia": "Corrente (0-30 giorni)",
    "cxc.vencido": "Scaduto (+30 giorni)",
    "cxc.credito_favor": "Credito cliente",
    "cxc.distribucion_antiguedad": "Distribuzione per scadenza",
    "cxc.buscar_cliente": "Cerca cliente, tel. o P.IVA...",
    "cxc.filtro.todos": "Tutti",
    "cxc.filtro.al_dia": "Corrente",
    "cxc.filtro.vencido": "Scaduto",
    "cxc.cliente": "Cliente",
    "cxc.contacto": "Contatto",
    "cxc.saldo": "Saldo",
    "cxc.credito": "Credito",
    "cxc.dias_mas_viejo": "Giorni",
    "cxc.ver_estado": "Vedi estratto",
    "cxc.estado_cuenta": "Estratto conto",
    "cxc.facturado": "Fatturato",
    "cxc.pagado": "Pagato",
    "cxc.pendiente": "In sospeso",
    "cxc.aplicar_pago": "Applica pagamento",
    "cxc.usar_credito": "Usa credito cliente",
    "cxc.facturas": "Fatture",
    "cxc.numero": "Numero",
    "cxc.fecha": "Data",
    "cxc.total": "Totale",
    "cxc.dias": "Giorni",
    "cxc.estado": "Stato",
    "cxc.estado.pagado": "Pagato",
    "cxc.estado.parcial": "Parziale",
    "cxc.estado.pendiente": "In sospeso",
    "cxc.historico_pagos": "Storico pagamenti",
    "cxc.factura": "Fattura",
    "cxc.monto": "Importo",
    "cxc.metodo": "Metodo",
    "cxc.nota": "Nota",
    "cxc.creditos_historicos": "Crediti generati",
    "cxc.monto_original": "Importo",
    "cxc.metodo_pago": "Metodo di pagamento",
    "cxc.metodo.efectivo": "Contanti",
    "cxc.metodo.transferencia": "Bonifico",
    "cxc.metodo.cheque": "Assegno",
    "cxc.metodo.tarjeta": "Carta",
    "cxc.preview_distribucion": "Anteprima distribuzione",
    "cxc.sobrante_credito": "Eccedenza (credito)",
    "cxc.confirmar_pago": "Conferma pagamento",
    "cxc.cancelar": "Annulla",
    "cxc.cargando": "Caricamento...",
    "cxc.sin_resultados": "Nessun risultato",
    "cxc.msg.pago_aplicado": "Pagamento applicato",
    "cxc.msg.facturas_pagadas": "Fatture pagate",
    "cxc.msg.facturas_parciales": "Fatture parziali",
    "cxc.msg.credito_generado": "Credito generato",
    "cxc.msg.credito_aplicato": "Credito applicato",
    "cxc.confirm.aplicar_credito": "Applicare il credito di",
    "cxc.confirm.a_facturas": "alle fatture in sospeso?",
    "cxc.error.estado_cuenta": "Errore caricamento estratto",
    "cxc.error.aplicar_pago": "Errore applicazione pagamento",
    "cxc.error.credito": "Errore",
    "cxc.error.monto_invalido": "Importo non valido",

    // Soft-delete - Activos/Inactivos
    "soft.mostrar_inactivos": "Mostra inattivi",
    "soft.desactivar": "Disattiva",
    "soft.restaurar": "Ripristina",
    "soft.eliminar_permanente": "Elimina definitivamente",
    "soft.confirm_desactivar": "Disattivare questo",
    "soft.podras_restaurar": "Potrai ripristinarlo dopo.",
    "soft.confirm_permanente_1": "ATTENZIONE: Questo elimina DEFINITIVAMENTE questo",
    "soft.confirm_permanente_2": "Questa azione NON può essere annullata.",
    "soft.confirm_permanente_3": "Continuare?",
    "soft.escribir_borrar": "Per confermare, scrivi BORRAR",
    "soft.cancelado": "Operazione annullata",
    "soft.error_desactivar": "Errore disattivazione",
    "soft.error_restaurar": "Errore ripristino",
    "soft.error_permanente": "Errore eliminazione definitiva",
    "soft.inactivo": "Inattivo",
    "soft.finalizado": "Completato",
    "soft.cancelado_estado": "Annullato",
  },
};
